// Copyright (c) Docugami, Inc. All rights reserved.

import { List } from "@fluentui/react";
import { emptyGray, greyText } from "components/shell/presentation/AppStyles";
import { ConfirmationDialog } from "components/shell/utils/ConfirmationDialog";
import styled from 'styled-components';

const StyledConfirmationDialog = styled(ConfirmationDialog)`
    .ms-Dialog-main{
        max-width: 420px;
    }
`

const ListContainer = styled.div`
    max-height: 150px;
    overflow: auto;
    border: 1px solid ${emptyGray};
    box-sizing: border-box;
`;

const CellContainer = styled.div<{ hasDivider?: boolean }>`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    padding: 4px;
    padding-left: 10px;
    box-sizing: border-box;
    color: ${greyText};
    border-top: ${props => !!props.hasDivider ? `1px solid ${emptyGray}4D` : 'none'};
`;

export interface UnsupportedFilesInfo {
    items: string[];
    totalCount?: number;
}

interface UnsupportedFilesModalProps {
    files: UnsupportedFilesInfo | null;
    onDismiss: () => void;
}

export const UnsupportedFilesModal = (props: UnsupportedFilesModalProps): JSX.Element | null => {
    if (!props.files) {
        return null;
    }

    const onRenderCell = (item?: string, index?: number): JSX.Element => {
        return <CellContainer hasDivider={index !== 0}>{item}</CellContainer>
    };

    return (
        <StyledConfirmationDialog
            hidden={!props.files}
            title={'Unsupported files'}
            subText={`${props.files?.items.length} of ${!!props.files?.totalCount ? props.files?.totalCount : 'the'} documents have been ignored due to unsupported file types or file path issues (invalid folder names).\n\nWe only support pdf and docx files at this time:`}
            confirmButtonText={'OK'}
            confirmedCallback={props.onDismiss}
            dismissedCallback={props.onDismiss}>
            <ListContainer>
                <List
                    style={{ display: "block", alignItems: "center", width: "100%" }}
                    items={props.files?.items}
                    onRenderCell={onRenderCell} />
            </ListContainer>
        </StyledConfirmationDialog>
    );
};
